import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "angle-right",
  "use": "angle-right-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"angle-right\">\n    <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M1.547 11.667L7 5.833 1.547 0 0 1.655l3.906 4.178L0 10.012z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol